/**
 * Vesper Event-Update Containers + Showcase Service (Shared, Phase 9)
 */

import apiClient from './api.client';
import type { UpdateFeedItem } from './update.service';

export interface ShowcaseEligibility {
  eligible: boolean;
  reason: string | null;
  remainingThisWeek: number;
  attendanceRate: number | null;
}

/** Get the visibility-gated feed of Updates from people RSVP'd "going" to this event. */
export async function getEventUpdates(eventId: string, limit = 50): Promise<UpdateFeedItem[]> {
  const res = await apiClient.get<{ data: { items: UpdateFeedItem[] } }>(
    `/events/${eventId}/updates?limit=${limit}`,
  );
  return res.data.data.items;
}

/** Pre-flight check: can the user showcase an Update at any event right now? */
export async function getShowcaseEligibility(): Promise<ShowcaseEligibility> {
  const res = await apiClient.get<{ data: ShowcaseEligibility }>(
    `/events/showcase/eligibility`,
  );
  return res.data.data;
}

/** Submit a showcase pick — links one of the user's Updates to a specific event. */
export async function submitShowcase(eventId: string, updateId: string): Promise<void> {
  await apiClient.post(`/events/${eventId}/showcase`, { updateId });
}
